import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'authenticated-user',
    templateUrl: './authenticated-user-ui.html',
    styleUrls: [],
    standalone: false
})
export class AuthenticatedUser implements OnInit {

    

    constructor() { }

    ngOnInit() {

    }
    onLogout = ()=> {

    }
    
}
